<template>
  <div>
    <div><strong>{{title}}</strong></div>
    <div><i>{{music}}</i></div>
    <div v-html="text"></div>
  </div>
</template>

<script>
export default {
  name:"Song",
  props:{
    title: String,
    text: String,
    music: String
  }
}
</script>

<style scoped>
div{
  text-align: left;
}
</style>